import {
  cartonCustomsIssueSchema,
  consolidationCartonLabelDraftSchema,
  consolidationCartonPurchasedLabelSchema,
} from "@redotech/redo-fulfillment-operations-common/consolidation-carton-label";
import {
  RateSchema,
  ShipmentMessageSchema,
} from "@redotech/redo-fulfillment-rate-common/outbound-labels";
import * as z from "zod";
import { consolidationCartonLabelInputSchema } from "./consolidation-carton-label-common";

const draftFingerprintSchema = z.string().min(1);
const shipmentMessagesSchema = z.record(
  z.string(),
  z.array(ShipmentMessageSchema),
);

export const quoteConsolidationCartonLabel = {
  name: "quoteConsolidationCartonLabel" as const,
  input: consolidationCartonLabelInputSchema.extend(
    consolidationCartonLabelDraftSchema.shape,
  ),
  output: z.discriminatedUnion("status", [
    z.object({
      draftFingerprint: draftFingerprintSchema,
      rates: z.array(RateSchema),
      shipmentMessages: shipmentMessagesSchema,
      status: z.literal("quoted"),
    }),
    z.object({
      draftFingerprint: draftFingerprintSchema,
      shipmentMessages: shipmentMessagesSchema,
      status: z.literal("no_rates"),
    }),
    z.object({
      draftFingerprint: draftFingerprintSchema,
      issues: z.array(z.string()),
      issueDetails: z.array(cartonCustomsIssueSchema).optional(),
      status: z.literal("missing_customs"),
    }),
    z.object({
      draftFingerprint: draftFingerprintSchema,
      status: z.literal("request_failed"),
    }),
    z.object({ issues: z.array(z.string()), status: z.literal("incomplete") }),
    z.object({
      purchasedLabel: consolidationCartonPurchasedLabelSchema,
      status: z.literal("purchased"),
    }),
  ]),
};
